import { Observable } from "rxjs/Observable"

import {
    KNOWLEDGE_LIST_REQUEST,
    KNOWLEDGE_LIST_RESPONSE,
    KNOWLEDGE_LIST_CACHED_RESPONSE,
    KNOWLEDGE_LIST_ERROR_RESPONSE,
    KNOWLEDGE_ITEM_REQUEST,
    KNOWLEDGE_ITEM_RESPONSE,
    KNOWLEDGE_ITEM_CACHED_RESPONSE,
    KNOWLEDGE_ITEM_ERROR_RESPONSE,
    KNOWLEDGE_ITEM_SAVE_REQUEST,
    KNOWLEDGE_ITEM_SAVE_RESPONSE,
    KNOWLEDGE_ITEM_SAVE_ERROR_RESPONSE,
    KNOWLEDGE_ANALYSE_REQUEST,
    KNOWLEDGE_ANALYSE_ERROR_RESPONSE
} from "../actions/action-types"
import { mapRequestError } from "./default-epics/epic-utils"
import {
    knowledgeAnalyseErrorResponse,
    knowledgeItemResponse,
    knowledgeItemSaveResponse,
    knowledgeItemSaveErrorResponse,
    knowledgeItemCachedResponse,
    knowledgeItemErrorResponse,
    knowledgeListCachedResponse,
    knowledgeListResponse,
    knowledgeListErrorResponse
} from "../actions/knowledge-actions"
import {
    hydrate as hydrateKnowledge,
    normalisingFields
} from "../models/entities/feed"
import { unauthenticated } from "../actions/authentication-actions"
import {
    getKnowledgeList,
    getKnowledgeItem,
    putKnowledgeItem,
    postKnowledgeItem
} from "../api/knowledge-api"
import {
    requestListEpic,
    requestItemEpic,
    requestItemSaveEpic,
    callbackActionCreatorEpic
} from "./default-epics/default-entity-epics"

export const requestKnowledgeListEpic = requestListEpic(
    KNOWLEDGE_LIST_REQUEST,
    getKnowledgeList,
    "knowledge",
    knowledgeListResponse,
    knowledgeListCachedResponse,
    knowledgeListErrorResponse
)

export const requestKnowledgeItemEpic = requestItemEpic(
    KNOWLEDGE_ITEM_REQUEST,
    getKnowledgeItem,
    "knowledge",
    hydrateKnowledge,
    normalisingFields,
    knowledgeItemResponse,
    knowledgeItemCachedResponse,
    knowledgeItemErrorResponse
)

export const requestKnowledgeItemSaveEpic = requestItemSaveEpic(
    KNOWLEDGE_ITEM_SAVE_REQUEST,
    putKnowledgeItem,
    () => null,
    "knowledge",
    knowledgeItemSaveResponse,
    knowledgeItemSaveErrorResponse
)

export const requestKnowledgeAnalyseEpic = (action$, { getState }) =>
    action$
        .ofType(KNOWLEDGE_ANALYSE_REQUEST)
        .mergeMap(
            ({
                data,
                dataType,
                shouldPersist,
                isSimple,
                callbackActionCreator
            }) =>
                postKnowledgeItem(
                    getState().authentication.token,
                    data,
                    dataType,
                    shouldPersist,
                    isSimple
                )
                    .map(data =>
                        knowledgeItemResponse(
                            data,
                            false,
                            callbackActionCreator
                        )
                    )
                    .catch(error =>
                        Observable.of(
                            mapRequestError(
                                error,
                                unauthenticated,
                                knowledgeAnalyseErrorResponse,
                                data,
                                dataType,
                                shouldPersist,
                                isSimple,
                                callbackActionCreator
                            )
                        )
                    )
        )

export const responseKnowledgeCallbackEpic = callbackActionCreatorEpic(
    KNOWLEDGE_LIST_RESPONSE,
    KNOWLEDGE_LIST_CACHED_RESPONSE,
    KNOWLEDGE_LIST_ERROR_RESPONSE,
    KNOWLEDGE_ITEM_RESPONSE,
    KNOWLEDGE_ITEM_SAVE_RESPONSE,
    KNOWLEDGE_ITEM_CACHED_RESPONSE,
    KNOWLEDGE_ITEM_ERROR_RESPONSE,
    KNOWLEDGE_ITEM_SAVE_ERROR_RESPONSE,
    KNOWLEDGE_ANALYSE_ERROR_RESPONSE
)
